import { useEffect } from "react";
import "./css/AboutUs.css";

import { ReactComponent as AboutSvg } from "../assets/undraw_reading_book_re_kqpk.svg";

function AboutUs() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main className="landing-about">
      <h1>Guiding Your Pursuit of Optimal Health</h1>
      <section className="section-vision">
        <div className="vision-container landing-container">
          <div className="left">
            <h2>Our vision</h2>
            <p>
              At PhysioTrack, our mission is to empower individuals to take
              control of their health and well-being. We believe that by
              providing intuitive tools and actionable insights, we can inspire
              positive lifestyle changes and help our users lead healthier,
              happier lives.
              <br />
              <br />
              Our vision is to create a world where everyone has access to
              personalized health tracking and analytics, enabling them to make
              informed decisions about their well-being. We aim to be at the
              forefront of innovation, leveraging technology to make health
              monitoring seamless and enjoyable for users of all backgrounds.
            </p>
          </div>
          <div className="right">
            <AboutSvg />
          </div>
        </div>
      </section>
    </main>
  );
}

export default AboutUs;
